import React from 'react';
import TopicTreeBrowser from './TopicTreeBrowser';

const TopicTreeSwitch = () => (
  <div className="topic-tree-switcher">
    <TopicTreeBrowser />
  </div>
);

export default TopicTreeSwitch;
